export function increasePagination(pageNumber: string) {
  if (typeof window !== "undefined") {
    const _data = window._data as { pagination?: string };
    _data.pagination = pageNumber;
  }
}
